import ApplicationAdapter from 'lumen/adapters/application';

export default class BeniHotelAdapter extends ApplicationAdapter {
  pathForType(): string {
    // Override to prevent EmberData from using the model name directly
    // (which would produce 'benchmark-insight/hotels' instead of 'benchmarkinsight/hotels').
    return 'benchmarkinsight/hotels';
  }
}
